// import React, { useState, memo, useRef } from "react";

// import {Button , ProgressBar} from "react-bootstrap";
// import Sound from 'react-sound';
// // import MicRecorder from 'mic-recorder-to-mp3';
// import ReusableRecorder from "../../Recorder/ReusableRecorder";

// import Microphone from "../../../assets/images/MicrophoneCheck.png";

// // const Mp3Recorder = new MicRecorder({ bitRate: 128 });

// const MicrophoneCheck = memo( function MicrophoneCheck({ setNextFlag }) {
// 	const [recordPer, setRecordPer] = useState(0);
// 	const [isRecording, setIsRecording] = useState(false);
// 	const [blobURL, setBlobURL] = useState('');
// 	const [btnText, setBtnText] = useState('Playback');
//     const recorderRef = useRef(null);

// 	// const startRecording = () => {
// 	// 	Mp3Recorder
// 	// 	.start()
// 	// 	.then(() => {
// 	// 		setIsRecording(true);
// 	// 		setBlobURL('');
// 	// 	});
// 	// };

// 	// const stopRecording = () => {
// 	// 	Mp3Recorder
// 	// 	.stop()
// 	// 	.getMp3()
// 	// 	.then(([buffer, blob]) => {
// 	// 		const blobURL = URL.createObjectURL(blob);

// 	// 		setIsRecording(false);
// 	// 		setBlobURL(blobURL);
// 	// 	});
// 	// };

// 	const handleRecordingComplete = (recordingData) => {
//   setBlobURL(recordingData.url);
//   setIsRecording(false);
// };

// const handleRecordingStart = () => {
//   setIsRecording(true);
//   setBlobURL('');
// };

// const startRecording = () => {
//   recorderRef.current?.startRecording();
// };

// const stopRecording = () => {
//   recorderRef.current?.stopRecording();
// };

// 	// const playRecording = () => {
// 	// 	if (btnText === "Playback") {
// 	// 		setBtnText("Stop Playback");
// 	// 	} else {
// 	// 		setBtnText("Playback");
// 	// 		setNextFlag(true);
// 	// 	}
// 	// };

// 	const playRecording = () => {
//   if (blobURL) {
//     const audio = new Audio(blobURL);
//     if (btnText === "Playback") {
//       setBtnText("Stop Playback");
//       audio.play();
//       audio.onended = () => {
//         setBtnText("Playback");
//         setNextFlag(true);
//       };
//     } else {
//       setBtnText("Playback");
//       audio.pause();
//       setNextFlag(true);
//     }
//   }
// };

// 	const handleRecordPlaying = (obj) => {
// 		setRecordPer(obj.position*100/obj.duration);
// 	}

// 	return (
// 		<div className="col-xs-12 successContent">
// 			<div className="row w-100">
// 				<div className="col-sm-8">
// 					<h4 className="mt-0">Microphone Check</h4>
// 					<h6>This is an opportunity to check that your microphone is working correctly</h6>
//                      <h6>Speaking works best with a proper headset and quiet environment.</h6>
// 					<ol>
// 						<li>Make sure your headset is on and the microphone is in the downward position near your mouth.</li>
// 						<li>When you are ready, click on the Record button and say "Testing, testing, one, two, three" into the microphone</li>
// 						<li>After you have spoken, cilck on the Stop button. Your recording is now complete</li>
// 						<li>Now click on the Playback button. You should clearly hear yourself speaking</li>
// 						<li>If you can not hear your voice clearly. please raise your hand to get the atteration of the Test Administrator</li>
// 					</ol>

// 					<div className="currentStatus">
// 						<p>Status: Click record to begin</p>
// 						<ProgressBar variant="info" now={recordPer} />
						
// 						<div className='stop-btn'>
// 							<Button
// 								variant="success"
// 								disabled={isRecording}
// 								className="p-5px"
// 								onClick={startRecording}
// 								size="xs"
// 							>Record</Button>
							
// 							<Button
// 								variant="success"
// 								onClick={playRecording}
// 								className="p-5px"
// 								size="xs"
// 							>{btnText}</Button>
							
// 							<Button
// 								variant="success"
// 								disabled={!isRecording}
// 								onClick={stopRecording}
// 								className="p-5px"
// 								size="xs"
// 							>Stop</Button>
// 						</div>
// 					</div>
// 				</div>
// 				<div className="col-sm-4">
//                     <div className="testingImgOuter">
//                       <img
//                         src={Microphone}
//                         alt="headset"
//                       />
//                     </div>
//                 </div>
// 			</div>

// 			<Sound
// 				autoLoad={true}
// 				url={blobURL}
// 				playStatus={btnText === "Stop Playback" ? Sound.status.PLAYING : Sound.status.STOPPED}
// 				onPlaying={handleRecordPlaying}
// 				onFinishedPlaying={playRecording}
// 			/>

// 			<ReusableRecorder
//   ref={recorderRef}
//   onRecordingComplete={handleRecordingComplete}
//   onRecordingStart={handleRecordingStart}
//   maxDuration={30000}
//   enableSpeechRecognition={false}
//   fileName="microphone-test.mp3"
// />
// 		</div>
// 	);
// });

// export default MicrophoneCheck;

import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import Sound from "react-sound";
import ReusableRecorder from "components/Recorder/ReusableRecorder.jsx";
import MicWaveform from "components/Question/Speaking/MicWaveform";
import stopImage from "../../../assets/images/stop recording.png";
import grayImage from "../../../assets/images/gray circle.png";
import HeadsetCheckImage from "../../../assets/images/HeadphoneNewCheck.png";

const MicrophoneCheck = ({ setNextFlag}) => {
  const recorderRef = useRef(null);
  const [recordPer, setRecordPer] = useState(0);
  const [isRecording, setIsRecording] = useState(false);
  const [recordingSoundStatus, setRecordingSoundStatus] = useState(false);
  const [btnText, setBtnText] = useState("Playback");
  const [blobURL, setBlobURL] = useState("");
  const [waveformKey, setWaveformKey] = useState(0);
  const [recordingStartTime, setRecordingStartTime] = useState(null);
  const [recordingInterval, setRecordingInterval] = useState(null);

  const startRecording = () => {
    setRecordPer(0);
    setBlobURL("");
    setWaveformKey(prev => prev + 1);
    recorderRef.current?.startRecording();
  };

  const stopRecording = () => {
    recorderRef.current?.stopRecording();
  };

  const playRecording = () => {
    if (recordingSoundStatus) {
      setRecordingSoundStatus(false);
      setBtnText("Playback");
      setNextFlag(true);
    } else {
      setRecordingSoundStatus(true);
      setBtnText("Stop Playback");
    }
  };

  const handleRecordingComplete = (recordingData) => {
    setBlobURL(recordingData.url);
    setIsRecording(false);
    setRecordPer(100);
    setNextFlag(true);
    setBtnText("Playback");
    if (recordingInterval) {
      clearInterval(recordingInterval);
      setRecordingInterval(null);
    }
  };

  const handleRecordingStart = () => {
    setIsRecording(true);
    setBlobURL("");
    setRecordPer(0);
    const startTime = Date.now();
    setRecordingStartTime(startTime);
    
    // Update progress every 100ms during recording
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min((elapsed / 40000) * 100, 100); // 40 seconds max
      setRecordPer(progress);
    }, 100);
    
    setRecordingInterval(interval);
  };

  const handleRecordingStop = () => {
    setIsRecording(false);
    if (recordingInterval) {
      clearInterval(recordingInterval);
      setRecordingInterval(null);
    }
  };

 const handleRecordPlaying = (obj) => {
  if (obj && typeof obj.duration === 'number' && obj.duration > 0) {
    setRecordPer((obj.position * 100) / obj.duration);
  } else {
    setRecordPer(0);
  }
};

  return (
    <div className="col-xs-12 successContent justify-content-start mock-resource-text">
      <div className="row w-100">
        <div className="col-sm-8">
          <h4 className="mt-0">Microphone Check</h4>
          <h6>This is an opportunity to check that your microphone is working correctly</h6>
          <h6>Speaking works best with a proper headset and quiet environment.</h6>
          <ol style={{ listStyleType: 'decimal', paddingLeft: '20px' }}>
            <li>Make sure your headset is on and the microphone is in the downward position near your mouth.</li>
            <li>When you are ready, click on the Record button and say "Testing, testing, one, two, three" into the microphone</li>
            <li>After you have spoken, click on the Stop button. Your recording is now complete</li>
            <li>Now click on the Playback button. You should clearly hear yourself speaking</li>
            <li>If you cannot hear your voice clearly. please raise your hand to get the attention of the Test Administrator</li>
          </ol>
          
          <div className="d-block d-lg-flex flex-column flex-md-row justify-content-start align-items-center gap-3" style={{ minHeight: "60px" }}>
            <div className="d-flex">
              {!isRecording && blobURL && (
                <Button variant="success" onClick={playRecording} className="custom-btn-design mock-bottom-btn border-0" size="xs">
                  {btnText}
                </Button>
              )}
              {isRecording ? (
                <Button variant="success" onClick={stopRecording} className="custom-btn-design mock-bottom-btn border-0" size="xs">
                  Stop
                </Button>
              ) : (
                <Button variant="success" className="custom-btn-design mock-bottom-btn border-0" onClick={startRecording} size="xs">
                  Record
                </Button>
              )}
            </div>
            <div className="d-flex gap-2 w-100 w-md-50">
              {isRecording ? (
                <img src={stopImage} alt="Stop Recording" style={{ height: "65px", width: "65px", objectFit: "contain", display: "block" }} />
              ) : (
                <div className="d-flex justify-content-center align-items-center">
                  <img src={grayImage} alt="Not Recording" style={{ height: "65px", width: "65px", objectFit: "contain", display: "block" }} />
                  <p className="text-center p-0 m-0" style={{ fontSize: "20px" }}>Ready</p>
                </div>
              )}
              <div className="d-flex align-items-center flex-grow-1 mb-4" style={{ height: "40px" }}>
                <div style={{ maxWidth: "300px", width: "100%" }}>
                  <MicWaveform key={waveformKey} progressValue={recordPer} mockColor="#0081A4" />
                </div>
              </div>
            </div>
          </div>
          
          <div className="note px-0">
            <ol start="6" style={{ listStyleType: 'decimal'}}>
              <li>During the test, you will not have Record, Playback, and Stop buttons. The voice recording will start automatically.</li>
            </ol>
          </div>
        </div>
        <div className="col-sm-4">
          <div className="testingImgOuter">
            <img src={HeadsetCheckImage} alt="headset" />
          </div>
        </div>
      </div>
      
      {blobURL && recordingSoundStatus && (
        <Sound url={blobURL} playStatus={Sound.status.PLAYING} onPlaying={handleRecordPlaying} onFinishedPlaying={playRecording} />
      )}
      
      <ReusableRecorder
        ref={recorderRef}
        onRecordingComplete={handleRecordingComplete}
        onRecordingStart={handleRecordingStart}
        onRecordingStop={handleRecordingStop}
        maxDuration={40000}
        enableSpeechRecognition={false}
        fileName="mic-test.mp3"
      />
    </div>
  );
};

export default MicrophoneCheck;

